import Com from "components/styledComp/CommStyledComp";
import sMiMs_페데스탈_제어_수도전기조명 from "assets/images/sMiMs_페데스탈 제어_수도전기조명.png";
import sMiMs_페데스탈_제어_수도전기조명2 from "assets/images/sMiMs_페데스탈 제어_수도전기조명2.png";
import sMiMs_관리자화면 from "assets/images/sMiMs_관리자화면.png";
import sMiMs_페데스탈제어_전기수도_사용자용_스마트폰_화면 from "assets/images/sMiMs_페데스탈제어_전기수도_사용자용 스마트폰 화면.png";
import sMiMs_페데스탈제어_전기수도_사용자용_스마트폰_화면2 from "assets/images/sMiMs_페데스탈제어_전기수도_사용자용 스마트폰 화면2.png";
import sMiMs_페데스탈제어_전기수도_사용자용_스마트폰_화면3 from "assets/images/sMiMs_페데스탈제어_전기수도_사용자용 스마트폰 화면3.png";
import React from "react";
import ZoomImg from "./ZoomImg";

const SmimsScreen = () => {
    return(
        <>
            <Com.DivDetailSection border={false}>
                <div className="strategy_cover">
                    <Com.StrongStrategy>페데스탈 제어 : 수도/전기/조명 – 관리자 화면</Com.StrongStrategy>
                    <div className="strategy_all">
                        <div className="strategy_1">
                                <ZoomImg img={sMiMs_페데스탈_제어_수도전기조명} width="100%" height="auto"/>
                        </div>
                        <div className="strategy_2">
                                <ZoomImg img={sMiMs_페데스탈_제어_수도전기조명2} width="100%" height="auto"/>
                        </div>
                    </div>
                </div>
                <div className="strategy_cover">
                    <div className="sampleImg">
                        <Com.StrongStrategy>페데스탈제어 : 전기/수도 – 사용자용 스마트폰 화면</Com.StrongStrategy>
                        <div className="strategy_all">
                            <div className="strategy_3">
                                <ZoomImg img={sMiMs_페데스탈제어_전기수도_사용자용_스마트폰_화면} width="100%" height="auto"/>           
                            </div>
                            <div className="strategy_4">
                                <ZoomImg img={sMiMs_페데스탈제어_전기수도_사용자용_스마트폰_화면2} width="100%" height="auto"/>
                            </div>
                            <div className="strategy_5">
                                <ZoomImg img={sMiMs_페데스탈제어_전기수도_사용자용_스마트폰_화면3} width="100%" height="auto"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="strategy_cover">
                    <div className="sampleImg">
                        <Com.StrongStrategy>선석관리 데시보드 – 관리자 화면</Com.StrongStrategy>
                        <div className="strategy">
                            <ZoomImg img={sMiMs_관리자화면} width="80%" height="auto"/>
                        </div>
                    </div>
                </div>
                
            </Com.DivDetailSection>
        </>
    );
}

export default SmimsScreen;